import api from '@/store/api'
import lottie from 'lottie-web'
import robotWithCat from '@/assets/image/toeic/toeic_exam/RobotWithCat.json'

let loadingAnimation = null

const formalExamJs = {
  methods: {
    post_records_purchase (id, type) {
      const path = '/assessments/records/?purchase=no'

      return api.post(path, { id, type })
        .then((response) => {
          return response.data
        })
        .catch((err) => {
          return err.response.data
        })
    },

    post_assessments_records_start (item) {
      // 考試開始
      const path = '/assessments/records/?purchase=yes'
      this.$store.dispatch('isLoading', true)

      api.post(path, { id: item.id, type: item.type })
        .then((res) => {
          this.$store.dispatch('isLoading', false)
          this.$store.dispatch('getRemainPoints')
          this.$router.push({
            name: this.returnRouter,
            params: { practice_type: item.type, exam_id: item.id },
            query: { record_id: res.data.record_id }
          })
        })
        .catch((err) => {
          this.$store.dispatch('isLoading', false)
          this.$swal.fire({
            focusConfirm: false,
            confirmButtonText: this.$t('GEPT.common.confirm'),
            title: this.$t('GEPT.common.notice'),
            text: err.response.data.msg || this.$t('GEPT.common.errorOccurred'),
            customClass: {
              title: 'text-white',
              container: '',
              popup: 'p-0',
              header: 'swal-header-notice justify-content-center align-items-center',
              closeButton: '',
              htmlContainer: 'font-semibold my-4 text-2xl',
              actions: 'mb-4 mt-2',
              confirmButton: 'btn-submit',
              cancelButton: 'bg-red-main-ai'
            }
          })
        })
    },

    finish_error_swal () {
      this.$swal.fire({
        title: this.$t('GEPT.alerts.answerHint'),
        html: this.$t('GEPT.alerts.unfinishedSentence'),
        showCloseButton: false,
        showConfirmButton: false,
        focusConfirm: false,
        showDenyButton: false,
        customClass: {
          container: '',
          popup: 'p-0 max-w-xl w-100',
          header: 'py-2 text-white gept_main_bg',
          title: 'text-white m-0 text-2xl py-2',
          closeButton: 'top-0 right-0 position-absolute',
          htmlContainer: 'p-6 font-bold leading-loose text-center text-lg',
          actions: 'mb-4 mt-5',
          confirmButton: 'submitButton-gept',
          denyButton: 'denyButton-gept'
        }
      })
    },

    async post_assessments_records (examId, questionId, part, text, file) {
      const path = `/assessments/records/${examId}`
      const formData = new FormData()
      formData.append('file', file)
      formData.append('id', questionId)
      formData.append('part', part)
      formData.append('text', text || '')

      const config = {
        headers: { 'Content-Type': 'multipart/form-data', showLoading: false }
      }

      const tryPost = async () => {
        try {
          const response = await api.post(path, formData, config)
          console.log('Upload success:', response.data)
          return response.data
        } catch (err) {
          console.error('Upload failed:', err)
          throw err
        }
      }

      try {
        return await tryPost()
      } catch (firstErr) {
        console.warn('Retrying upload...')
        try {
          return await tryPost()
        } catch (secondErr) {
          console.error('Upload failed twice:', secondErr)
          return Promise.reject(secondErr)
        }
      }
    },

    post_gept_records_finish (examId) {
      this.showScoreCalculatingSwal()

      let attempt = 0
      const maxRetries = 20
      const retryInterval = 5000
      const path = `/assessments/records/${examId}/finish`
      const options = { headers: { showLoading: false } }

      this.$store.dispatch('isLoading', true)

      const makeRequest = () => {
        return api.post(path, options)
          .then(() => true)
          .catch(() => {
            attempt++
            if (attempt < maxRetries) {
              return new Promise(resolve => {
                setTimeout(() => resolve(makeRequest()), retryInterval)
              })
            }
            throw new Error('max retries reached')
          })
      }

      makeRequest()
        .then(() => {
          const isQuiz = this.$route.path.includes('quiz')

          this.$router.push({
            name: isQuiz ? 'quiz_report_formal' : 'gept_report_formal',
            params: { record_id: examId }
          })
        })
        .catch(() => {
          this.$swal.fire({
            icon: 'error',
            title: this.$t('GEPT.alerts.scoreFailedTitle'),
            text: this.$t('GEPT.alerts.scoreFailedText')
          })
        })
        .finally(() => {
          this.$store.dispatch('isLoading', false)
          this.closeScoreLoading()
        })
    },

    get_assessments_records (examId) {
      const path = `/api/toeic/exams/${examId}/records`

      return api.get(path)
        .then((res) => {
          return res
        })
        .catch(() => {})
    },

    post_gept_records_byFormal (examId, questionId, part, text, file) {
      const path = `assessments/records/${examId}`

      this.$store.dispatch('isLoading', true)

      const formData = new FormData()
      formData.append('file', file)
      formData.append('id', questionId)
      formData.append('part', part)
      formData.append('text', text)

      return api.post(path, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
        .then((response) => {
          this.$store.dispatch('isLoading', false)
          return response.data
        })
        .catch((err) => {
          this.$store.dispatch('isLoading', false)
          return err.response
        })
    },

    checkSubmitReport (pName, pType) {
      const displayName = this.geptDisplayText ? this.geptDisplayText(pName) : pName
      const displayType = this.geptDisplayText ? this.geptDisplayText(pType) : pType
      const html = `<p class="gept_main_color4 text-2xl mb-4">${this.$t('GEPT.alerts.confirmCompleteTitle', { name: displayName, type: displayType })}</p>
      <p class="text-left mb-2">${this.$t('GEPT.alerts.aiCorrectionDesc')}</p>
      <p class="text-left mb-1">${this.$t('GEPT.alerts.currentTotalPoints', { points: this.$store.state.remainPoints })}</p>
      <p class="text-left mb-1">${this.$t('GEPT.alerts.pointsToDeduct', { points: 10 })}</p>
      <p class="text-left">${this.$t('GEPT.alerts.pointsAfterDeduct', { points: this.$store.state.remainPoints - 0 })}</p>`

      return this.$swal({
        html,
        showDenyButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t('GEPT.common.confirm'),
        denyButtonText: this.$t('GEPT.common.back'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-4',
          header: 'p-0',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-4 text-left',
          actions: 'mb-4 mt-2',
          confirmButton: 'submitButton-gept order-2',
          denyButton: 'denyButton-gept order_1'
        }
      })
        .then((result) => {
          return result.isConfirmed === true
        })
    },

    showScoreCalculatingSwal () {
      this.$swal.fire({
        html: `
          <div class="d-flex justify-content-center flex-column align-items-center">
            <div id="score-lottie" style="width:300px; margin-bottom:16px;"></div>
            <p style="font-size:1.5rem; font-weight:bold; text-align:center;">
              ${this.$t('GEPT.alerts.calculatingScore')}
            </p>
          </div>
        `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: '#fff',
        customClass: {
          title: '',
          container: '',
          popup: 'p-5',
          header: '',
          closeButton: '',
          htmlContainer: '',
          actions: '',
          confirmButton: '',
          denyButton: ''
        },
        didOpen: () => {
          loadingAnimation = lottie.loadAnimation({
            container: document.getElementById('score-lottie'),
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: robotWithCat
          })
        },
        willClose: () => {
          if (loadingAnimation) {
            loadingAnimation.destroy()
            loadingAnimation = null
          }
        }
      })
    },

    closeScoreLoading () {
      this.$swal.close()
    }
  }
}

export default formalExamJs
